import { gql } from '@apollo/client';

export const GET_UNIFIED_PERMITS = gql`
  query ReadUnifyPermits {
    readUnifyPermits {
      identifyCustomerFromPermit
      id
      orderLineIdWithVersion
      permitType
      maxLicensePlates
      parkingFacilityName
      isWaitingActivation
      created
      validity {
        validFrom
        validTo
      }
      startDate
      endDate
      creditCardId
      paymentState
      renewal
      isRenewalDisabled
      scheduledTerminationDate
      orderStatus
      countryCode
      logo
      link
      usageType
      pmcName
      pmcDescription {
        en
        fi
        sv
        no
      }
      vatPercent
      registrationPlates {
        plateText
        countryCode
      }
      salesLocationUid
      salesLocation {
        uid
        name
        parkingZones
        description
      }
      parkingZoneUid
      paymentMethod
      placeName
      lock {
        expiration
      }
      accessToCustomerSegmentUid
      accessPermitPoolingGroupInfo {
        uid
        name
        parkingZoneUids
        freePoolingSpots
        poolSize
        parkingZoneName
        salesLocationName
        lastFetch
        insidePool
        outsidePool
        capacityHidden
        validity {
          validFrom
          validTo
        }
        customerSegmentInsidePool
        customerSegmentOutsidePool
        pmcName
      }
      orderLines {
        pmcId
        salesOrderId
        salesOrderStatus
        salesOrderPaymentState
        orderLineId
        lineTotal
        version
        quantity
        lineVatAmount
        billingFrequency
        billingType
        serviceFeeAmount
        serviceFeeAmountWithoutVat
        registrationPlates {
          plateText
          countryCode
        }
        parkingSpace {
          name
        }
        parkingSpaces {
          uid
          name
        }
        parkingSpaceUids
        validity {
          validFrom
          validTo
        }
        charge {
          uid
          salesOrderUid
          orderLineId
          validity {
            validFrom
            validTo
          }
          creditCardEvents {
            content {
              created
            }
          }
        }
        useAdditionalDiscount
        additionalDiscount {
          percent
          value
          validity {
            validFrom
            validTo
          }
        }
        promotion {
          uid
          promoCode
          name {
            en
            fi
            sv
            no
          }
          percent
          value
          addAutomatically
          validity {
            validFrom
            validTo
          }
        }
        pmc {
          name
          physicalZoneUid
          salesLocationUid
          attachmentPolicy
          expirationLimit
          expirationLimits {
            authoriseFailure
          }
          doShortTermPriceCalculation
          maxLicensePlatesPerQuantity
          reservationType
          prices {
            thirtyDayPrice
            monthlyPrice
            halfYearPrice
            quarterlyPrice
            annualPrice
            validity {
              validFrom
            }
            serviceFee
          }
          parkZone {
            name
            locationType
            countryCode
            commercialZoneView {
              name
              zoneCode
            }
            address {
              street
              marker
              number
              city
            }
            info {
              doorCode
            }
            spotMap
          }
          salesLocation {
            uid
            name
            parkingZones
            description
          }
        }
      }
      resolvedParkingSpaces {
        uid
        name
        type
        reserved
        blocked
        externalNote
        accessDeviceExternalNote
      }
      spotMap
      quantity
      positionInWaitingList
      billingFrequency
      freetextParkingSpaceNo
      attachments {
        uid
        fileName
        mimeType
        sizeBytes
      }
    }
  }
`;
